export default __webpack_public_path__ + "static/media/Yodlee.60fa35c8.svg";